import { useId, useState } from 'react';
import { Button, Dialog } from '../../../ds/components';
import { useRefreshFinancing, type FinancierRecordFields } from './api';
import { SignatureForm } from './SignatureForm';

/**
 * „Fina-Unterschrift erfassen" from the record header (Finanzierungen 06 for the financier, Finanzierer 07 outside the
 * overview): the FZ-07 form in a dialog.
 */
export function SignatureDialog({
  financing,
  open,
  onClose,
}: {
  financing: FinancierRecordFields;
  open: boolean;
  onClose: () => void;
}) {
  const formId = useId();
  const refresh = useRefreshFinancing(financing.id);
  const [pending, setPending] = useState(false);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      width={720}
      eyebrow={`${financing.numberLabel} · ${financing.linked.contact.name}`}
      title="Finanzierungsvertrag unterschrieben?"
      subtitle="Mit dem Datum steht die Finanzierung auf „Unterschrieben“. Das geht auch, wenn der Vertrag offline auf Papier unterschrieben wurde, etwa in der Filiale."
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Abbrechen
          </Button>
          <Button type="submit" form={formId} loading={pending}>
            Unterschrift erfassen
          </Button>
        </>
      }
    >
      {open ? (
        <SignatureForm
          financing={financing}
          variant="dialog"
          formId={formId}
          onPendingChange={setPending}
          onDone={() => {
            void refresh();
            onClose();
          }}
        />
      ) : null}
    </Dialog>
  );
}
